import axios from "axios";
import Cookies from "js-cookie";

// export const baseURLImage = "https://api.shghealth.com/";
export const baseURLImage = "https://shgapi.aladdinapps.com/";
const API = axios.create({
  baseURL: "https://shgapi.aladdinapps.com/",
  // baseURL: "https://api.shghealth.com/",
  headers: { "ngrok-skip-browser-warning": "true" },
});
API.interceptors.request.use((req) => {
  if (Cookies.get("token")) {
    req.headers.Authorization = `Bearer ${Cookies.get("token")}`;
  }
  return req;
});

export default API;
